﻿<template>
    <div class="notice-template">
        <el-card>
            <div slot="header">
                <h3>通知书模板管理</h3>
            </div>
            
            <div class="template-list">
                <div v-for="template in templates" :key="template.id" class="template-item">
                    <div class="template-info">
                        <i class="el-icon-document"></i>
                        <span class="template-name">{{ template.name }}</span>
                        <span v-if="template.isDefault" class="default-tag">默认模板</span>
                        <span class="template-size">{{ template.size }}</span>
                        <span class="template-date">{{ template.date }}</span>
                    </div>
                    <div class="template-actions">
                        <el-button type="text" @click="editTemplate(template)">编辑</el-button>
                        <el-button type="text" @click="previewTemplate(template)">预览</el-button>
                        <el-button type="text" @click="setDefault(template)">{{ template.isDefault ? '取消默认' : '设为默认' }}</el-button>
                        <el-button type="text" @click="deleteTemplate(template)" class="delete-btn">删除</el-button>
                    </div>
                </div>
                
                <div v-if="templates.length === 0" class="empty-state">
                    <i class="el-icon-document"></i>
                    <p>暂无模板，请上传PDF文件</p>
                </div>
            </div>
            
            <div class="upload-section">
                <el-upload
                    class="upload-demo"
                    drag
                    :action="uploadUrl"
                    :headers="uploadHeaders"
                    :on-success="handleUploadSuccess"
                    :on-error="handleUploadError"
                    :before-upload="beforeUpload"
                    accept=".pdf">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将PDF文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">只能上传PDF格式文件，文件大小不超过50MB</div>
                </el-upload>
            </div>
        </el-card>

        <el-dialog
            title="模板预览"
            :visible.sync="previewVisible"
            width="80%"
            top="5vh">
            <div class="preview-container">
                <iframe :src="previewUrl" class="pdf-preview" frameborder="0"></iframe>
            </div>
        </el-dialog>

        <el-dialog
            title="编辑模板字段"
            :visible.sync="editVisible"
            width="90%"
            top="5vh"
            :close-on-click-modal="false"
            @opened="handleDialogOpened">
            <NoticeTemplateEditor
                ref="templateEditor"
                :template-id="editingTemplate.id"
                :template-name="editingTemplate.name"
                @saved="handleEditSaved"
                @cancel="editVisible = false" />
        </el-dialog>
    </div>
</template>

<script>
    import { TYBM_Env } from '../../env.js';
    import { TYBM_Tools } from '../../tools.js';
    import NoticeTemplateEditor from './NoticeTemplateEditor.vue';

    export default {
        name: 'NoticeTemplate',
        components: {
            NoticeTemplateEditor
        },
        data() {
            return {
                templates: [],
                uploadUrl: '',
                uploadHeaders: {},
                previewVisible: false,
                previewUrl: '',
                editVisible: false,
                editingTemplate: {
                    id: '',
                    name: ''
                }
            };
        },
        mounted() {
            this.initUploadConfig();
            this.loadTemplates();
        },
        methods: {
            initUploadConfig() {
                this.uploadUrl = TYBM_Env.GetApiUrl('/Notice/UploadTemplate');
                this.uploadHeaders = {
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token') || ''
                };
            },
            loadTemplates() {
                const api_name = '/Notice/GetTemplates';
                const url = TYBM_Env.GetApiUrl(api_name);
                
                TYBM_Tools.AxiosPostEx(this, api_name, url, {}, { loading: false, show_error: false })
                    .then(response => {
                        this.templates = response.data || [];
                    })
                    .catch(() => {
                        this.$message.error('加载模板列表失败');
                    });
            },
            beforeUpload(file) {
                const isPdf = file.type === 'application/pdf';
                const isLt50M = file.size / 1024 / 1024 < 50;
                
                if (!isPdf) {
                    this.$message.error('只能上传PDF格式文件');
                }
                if (!isLt50M) {
                    this.$message.error('文件大小不能超过50MB');
                }
                
                return isPdf && isLt50M;
            },
            handleUploadSuccess(response) {
                if (response && response.code === 'ok') {
                    this.$message.success('上传成功');
                    this.loadTemplates();
                } else {
                    this.$message.error(response && response.errmsg || '上传失败');
                }
            },
            handleUploadError() {
                this.$message.error('上传失败，请重试');
            },
            editTemplate(template) {
                this.editingTemplate = {
                    id: template.id,
                    name: template.name
                };
                this.editVisible = true;
            },
            handleDialogOpened() {
                if (this.$refs.templateEditor) {
                    this.$refs.templateEditor.loadPdf();
                }
            },
            handleEditSaved() {
                this.editVisible = false;
                this.$message.success('字段配置已保存');
            },
            previewTemplate(template) {
                this.previewUrl = TYBM_Env.GetApiUrl('/Notice/PreviewTemplate') + '?id=' + template.id + '&t=' + Date.now();
                this.previewVisible = true;
            },
            setDefault(template) {
                const api_name = '/Notice/SetDefaultTemplate';
                const url = TYBM_Env.GetApiUrl(api_name);
                
                TYBM_Tools.AxiosPostEx(this, api_name, url, { id: template.id })
                    .then(response => {
                        if (response.code === 'ok') {
                            this.$message.success('设置成功');
                            this.loadTemplates();
                        } else {
                            this.$message.error(response.errmsg || '设置失败');
                        }
                    })
                    .catch(() => {
                            this.$message.error('设置失败');
                        });
            },
            deleteTemplate(template) {
                this.$confirm('确定要删除该模板吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const api_name = '/Notice/DeleteTemplate';
                    const url = TYBM_Env.GetApiUrl(api_name);
                    
                    TYBM_Tools.AxiosPostEx(this, api_name, url, { id: template.id })
                        .then(response => {
                            if (response.code === 'ok') {
                                this.$message.success('删除成功');
                                this.loadTemplates();
                            } else {
                                this.$message.error(response.errmsg || '删除失败');
                            }
                        })
                        .catch(() => {
                                this.$message.error('删除失败');
                            });
                }).catch(() => { });
            }
        }
    };
</script>

<style scoped>
    .notice-template {
        padding: 20px;
    }

    .template-list {
        margin-bottom: 20px;
    }

    .template-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 20px;
        background: #f9fafc;
        border-radius: 8px;
        margin-bottom: 10px;
        transition: all 0.3s;
    }

    .template-item:hover {
        background: #f0f2f5;
    }

    .template-info {
        display: flex;
        align-items: center;
        gap: 15px;
    }

    .template-info i {
        font-size: 24px;
        color: #409EFF;
    }

    .template-name {
        font-size: 16px;
        font-weight: 500;
        min-width: 200px;
    }

    .template-size, .template-date {
        font-size: 14px;
        color: #909399;
    }

    .template-actions {
        display: flex;
        gap: 20px;
    }

    .delete-btn {
        color: #f56c6c;
    }

    .empty-state {
        text-align: center;
        padding: 60px 0;
        color: #909399;
    }

    .empty-state i {
        font-size: 48px;
        margin-bottom: 16px;
        display: block;
    }

    .upload-section {
        margin-top: 20px;
    }

    .preview-container {
        width: 100%;
        height: 600px;
        background-color: #f5f5f5;
        border-radius: 8px;
        overflow: hidden;
    }

    .pdf-preview {
        width: 100%;
        height: 100%;
    }

    ::v-deep .el-dialog__body {
        height: calc(85vh - 55px);
        overflow: hidden;
        padding: 10px;
    }

    .default-tag {
        background-color: #67c23a;
        color: white;
        padding: 2px 8px;
        border-radius: 4px;
        font-size: 12px;
        margin-left: 8px;
    }
</style>